import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchUnitOfMeasurements } from '../NomenclaturesPage/services';

export const useUnitOfMeasurements = () => {
  const { data: units } = useQuery({
    queryKey: ['unit-of-measurements'],
    queryFn: fetchUnitOfMeasurements,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const unitsMap = useMemo(() => {
    if (!units) return new Map<number, string>();
    return new Map(units.map((u) => [u.id, u.description]));
  }, [units]);

  return { units, unitsMap };
};
